import { useUI } from "providers/UIProvider"

import { Box, Flex, Text, Center } from "@chakra-ui/react"
import { ICompanyBranchesCountProps } from "./CompanyBranchesTypes"

import Icon from "components/UI/atoms/Icon"

const CompanyBranchesCount: React.FC<ICompanyBranchesCountProps> = ({
  count,
  onClick,
  dropdownOpened,
  selectedAll,
}) => {
  const { T } = useUI()

  return (
    <Box
      as="button"
      backgroundColor="error"
      borderTopRadius="base"
      borderBottomRadius={`${dropdownOpened ? "0" : "base"}`}
      pointerEvents={dropdownOpened ? "none" : "auto"}
      boxShadow="primary"
      fontSize="l"
      color="white"
      padding="10px 15px"
      onClick={onClick}
    >
      <Flex alignItems="center">
        {selectedAll ? (
          <Text>{T("general.all")}</Text>
        ) : (
          // <Image src={imgSrc} alt="Company" width="45px" />
          <></>
        )}

        <Center
          backgroundColor="white"
          borderRadius="xs"
          fontSize="base"
          color="main_text_color"
          w="37px"
          h="37px"
          m="0 16px"
        >
          {count}
        </Center>
        <Icon name="dropdown" iconStyles={{ width: "8px", fill: "white" }} />
      </Flex>
    </Box>
  )
}

export default CompanyBranchesCount
